import { useEffect } from 'react';

import { VoiceDialog } from 'entities/voice';

import { Country, Voices } from 'shared/api';

type Props = {
  voice: Voices | null;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: Partial<Voices>) => void;
  isSuccess: boolean;
  isLoading: boolean;
  countries: Country[];
};

export const EditVoice = ({ voice, isOpen, onClose, onSubmit, isSuccess, isLoading, countries }: Props) => {
  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess, onClose]);

  return (
    <VoiceDialog
      title="Edit voice"
      isOpen={isOpen}
      voice={voice ?? undefined}
      onClose={onClose}
      onSubmit={onSubmit}
      isLoading={isLoading}
      countries={countries}
    />
  );
};
